<script>
import BasePublicationsCriteriaExpansionTable from '@/components/admin/collector/publications/BasePublicationsCriteriaExpansionTable.vue'

export default {
  name: 'PublicationsCriteriaExpansionTable',
  extends: BasePublicationsCriteriaExpansionTable,
}
</script>
